import { Globe, Link2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip } from '@/components/ui/Tooltip';
import { PROFESSIONAL_VISIBILITY_HINTS } from '@/constants/professional/visibility';

interface ProfessionalVisibilityIconProps {
	visibility?: Professionals.Visibility;
	className?: string;
}

const ProfessionalVisibilityIcon = ({
	visibility,
	className,
}: ProfessionalVisibilityIconProps) => {
	if (!visibility) {
		return (
			<span
				className="text-[11px] text-gray-400"
				title="Visibilidade não informada"
			>
				—
			</span>
		);
	}

	const isPublic = visibility === 'PUBLIC_SEARCH';
	const Icon = isPublic ? Globe : Link2;
	const hint = PROFESSIONAL_VISIBILITY_HINTS[visibility];

	return (
		<Tooltip
			content={hint}
			position="top"
			className="max-w-[16rem] whitespace-normal text-left leading-snug"
		>
			<span
				className={cn(
					'inline-flex size-7 cursor-help items-center justify-center rounded-lg ring-1',
					isPublic
						? 'bg-emerald-50 text-emerald-600 ring-emerald-100'
						: 'bg-stone-100 text-stone-500 ring-stone-200/80',
					className,
				)}
				aria-label={hint}
			>
				<Icon className="size-3.5" strokeWidth={2.25} aria-hidden />
			</span>
		</Tooltip>
	);
};

export { ProfessionalVisibilityIcon };
